(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smackdown-wheel-lab"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready==='true')return;root.dataset.ready='true';
    var stage=root.querySelector('[data-stage]'),empty=root.querySelector('[data-empty]'),car=root.querySelector('[data-car]'),upload=root.querySelector('[data-upload]'),wheelUpload=root.querySelector('[data-wheel-upload]'),left=root.querySelector('[data-wheel-left]'),right=root.querySelector('[data-wheel-right]'),size=root.querySelector('[data-size]'),blend=root.querySelector('[data-blend]'),reset=root.querySelector('[data-reset]'),shop=root.querySelector('[data-shop]'),title=root.querySelector('[data-selected-title]'),search=root.querySelector('[data-search]'),cards=Array.prototype.slice.call(root.querySelectorAll('[data-wheel-card]')),wheels=[left,right];
    function defaults(){left.style.left='31%';left.style.top='69%';right.style.left='69%';right.style.top='69%'}
    function applySize(){wheels.forEach(function(w){w.style.width=size.value+'%'})}
    function applyBlend(){wheels.forEach(function(w){w.classList.toggle('is-blended',blend.checked)})}
    function hasPhoto(){return !car.hidden}
    function hasWheel(){return !!left.getAttribute('src')}
    upload.addEventListener('change',function(){var file=upload.files&&upload.files[0];if(!file)return;var reader=new FileReader();reader.addEventListener('load',function(){car.src=reader.result;car.hidden=false;empty.hidden=true;if(hasWheel()){left.hidden=false;right.hidden=false}defaults()});reader.readAsDataURL(file)});
    if(wheelUpload)wheelUpload.addEventListener('change',function(){var file=wheelUpload.files&&wheelUpload.files[0];if(!file)return;var reader=new FileReader();reader.addEventListener('load',function(){cards.forEach(function(i){i.classList.remove('is-active')});wheels.forEach(function(w){w.src=reader.result;w.alt='Uploaded wheel image';w.hidden=!hasPhoto()});title.textContent='Uploaded Wheel Image';shop.href='#';shop.classList.add('is-disabled');shop.setAttribute('aria-disabled','true');defaults();applySize();applyBlend()});reader.readAsDataURL(file)});
    size.addEventListener('input',applySize);blend.addEventListener('change',applyBlend);reset.addEventListener('click',defaults);
    cards.forEach(function(card){card.addEventListener('click',function(){cards.forEach(function(i){i.classList.remove('is-active')});card.classList.add('is-active');var image=card.dataset.image,name=card.dataset.title,url=card.dataset.url;wheels.forEach(function(w){w.src=image;w.alt=name;w.hidden=!hasPhoto()});title.textContent=name;shop.href=url;shop.classList.remove('is-disabled');shop.removeAttribute('aria-disabled');defaults();applySize();applyBlend()})});
    function drag(wheel){var active=false;wheel.addEventListener('pointerdown',function(e){active=true;wheel.setPointerCapture(e.pointerId);e.preventDefault()});wheel.addEventListener('pointermove',function(e){if(!active)return;var b=stage.getBoundingClientRect(),x=Math.max(0,Math.min(100,((e.clientX-b.left)/b.width)*100)),y=Math.max(0,Math.min(100,((e.clientY-b.top)/b.height)*100));wheel.style.left=x+'%';wheel.style.top=y+'%'});wheel.addEventListener('pointerup',function(){active=false});wheel.addEventListener('pointercancel',function(){active=false})}
    wheels.forEach(drag);
    if(search)search.addEventListener('input',function(){var q=search.value.trim().toLowerCase();cards.forEach(function(card){card.hidden=q.length>0&&card.dataset.title.toLowerCase().indexOf(q)===-1})});
    applySize();applyBlend();defaults()
  }
  function boot(){document.querySelectorAll('[data-wheel-lab]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot)
})();

  } catch(e) { console.error(e); }
})();
})();
